import {
    Image,
} from "@chakra-ui/react";
import React, {useEffect, useRef, useState} from "react";

import Markdown from "./Markdown";

type ResourceProps = {
  id: string;
  
  content: string;
  compact?: boolean;
  debug?: boolean;
};

const RenderText = (props: ResourceProps) => {
  const domtoimage = require('dom-to-image-improved');
  const [sourceUrl, setSourceUrl] = useState<string>();
  const [oldId, setOldId] = useState<string>();
  const node = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (node?.current && (!sourceUrl || oldId !== props.id)) {
      node.current.style.display = "block";

      setSourceUrl("");
      domtoimage.toPng(node.current, { copyDefaultStyles: false,
        width:node.current.clientWidth}).then(function (dataUrl: any) {
        setOldId(props.id);
        setSourceUrl(dataUrl);
        if (node?.current)
          node.current.style.display = "none";
      });
    }

  }, [domtoimage, props.id])

  /*
  useEffect(() => {
    if (node?.current && sourceUrl) {
      node.current.style.display = "none";
    }
  }, [sourceUrl])*/

    return (
      <>
        <div ref={node}>
          <Markdown content={props.content} compact={props.compact} />
        </div>
        <Image src={sourceUrl}
               alt={props.id}
               pointerEvents={"none"}
               minW={"100%"}
        />
      </>
    )
}


export default RenderText;
